import { render, staticRenderFns } from "./RejectionReasonForm.vue?vue&type=template&id=d2a3c5e0&scoped=true&"
import script from "./RejectionReasonForm.vue?vue&type=script&lang=js&"
export * from "./RejectionReasonForm.vue?vue&type=script&lang=js&"
import style0 from "./RejectionReasonForm.vue?vue&type=style&index=0&id=d2a3c5e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2a3c5e0",
  null
  
)

export default component.exports